import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setOnCompletion } from '../store/slices/scenarioSlice';
import { useSelectedDevices } from './useSelectedDevices';

export const useScenarioHandler = () => {
  const dispatch = useDispatch();
  const { scenario, parentOrigin } = useSelector((s) => s.scenario);
  const { hideVideo, muted } = useSelector((s) => s.device);
  const selectedDevices = useSelectedDevices();

  useEffect(() => {
    if (!parentOrigin) return;

    const send = (payload) =>
      window.parent.postMessage({ type: 'completed', payload }, parentOrigin);

    const onCompletion = () => {
      if (scenario === 'lobby' || scenario === 'meeting') {
        send({
          devices: selectedDevices,
          startAsMuted: muted,
          startAsHidden: hideVideo,
        });
      } else {
        send({ completed: true, action: 'navigateBackOrClose' });
      }
    };

    dispatch(setOnCompletion(onCompletion));
  }, [dispatch, scenario, parentOrigin, selectedDevices, muted, hideVideo]);
};
